import { useAtom } from 'jotai';
import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { MDSButton, MDSIcon, MDSTypography } from '@marqvision/mds-v2';
import { firstAlertAtom } from '~/atoms';
import { useUserInfoQuery } from '~/apis/auth';
import { RootRouteEnum, SettingsRouteEnum } from '~/router/@types';
import { useLogger } from '~/hooks';

const useStyles = makeStyles(({ color }) => ({
  wrapper: {
    position: 'absolute',
    zIndex: 1,
    padding: '6px 12px',
    borderRadius: '8px',
    backgroundColor: color.content.critical.default.normal,
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 8px 16px 0px rgba(0, 0, 0, 0.20)',
    top: `${6.5}px`,
    left: '50%',
    transform: 'translate(-50%)',
    '&.isAdmin': {
      top: `${48 + 6.5}px`,
    },
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: '4px',
    '& > *:nth-child(2)': {
      marginRight: '12px',
    },
  },
}));

export const GlobalAlert = () => {
  const classes = useStyles();
  const { amplitudeLogging } = useLogger();
  const [firstAlert] = useAtom(firstAlertAtom);
  const { data: auth } = useUserInfoQuery();
  const location = useLocation();

  const handleClick = () => {
    if (!firstAlert) return;

    amplitudeLogging('clicked notification', {
      type: firstAlert.type,
    });
  };

  if (
    !firstAlert ||
    (firstAlert.excludedRoutes &&
      firstAlert.excludedRoutes.length > 0 &&
      firstAlert.excludedRoutes.some((route) => location.pathname.startsWith(route)))
  )
    return null;

  return (
    <div className={clsx(classes.wrapper, { isAdmin: auth?.isAdmin })}>
      <div className={classes.content}>
        {firstAlert.type === 'unpaid' && (
          <>
            <MDSIcon.Info variant="fill" size={16} color="color/content/inverse/default/normal" />
            <MDSTypography size="m" weight="medium" color="color/content/inverse/default/normal">
              You have {firstAlert.count} unpaid {`invoice${firstAlert.count > 1 ? 's' : ''}`}. Check your payment.
            </MDSTypography>
            <Link to={`/${RootRouteEnum.Settings}/${SettingsRouteEnum.Billing}`}>
              <MDSButton variant="border" color="red" size="small" onClick={handleClick}>
                Go to Billing
              </MDSButton>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};
